// Unused while the animation below is disabled: a static import put all of
// lottie-web (~250 KB) in the main bundle of every page. If the animation
// comes back, reinstall lottie-web and import it dynamically.
// import lottie from "lottie-web";
// import arrowData from "../../../assets/lottie/arrow.json";

export default class Cta {
  constructor(el) {
    this.el = el;
    this.container = el.querySelector(".c-cta__lottie");
    if (!this.container) return;

    // this.anim = lottie.loadAnimation({
    //   container: this.container,
    //   animationData: arrowData,
    //   renderer: "svg",
    //   loop: false,
    //   autoplay: false,
    // });

    // this.anim.setSpeed(1);

    // this.anim.addEventListener("DOMLoaded", () => {
    //   this.container.querySelectorAll("svg [fill='rgb(255,255,255)']").forEach((el) => {
    //     el.setAttribute("fill", "currentColor");
    //   });
    // });

    // this.el.addEventListener("mouseenter", () => {
    //   this.anim.goToAndPlay(0, true);
    // });
  }
}
